import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CompanyEmployeeController', CompanyEmployeeController);

    /** @ngInject */
    function CompanyEmployeeController(
        $locale,
        $state,
        AgreementsDialogService,
        AuthFactory,
        CompanyFactory,
        CompaniesFactory,
        GdprFactory,
        RouteStateService,
        WebPushService,
        VersionService
    ) {
        var vm = this;

        init();

        function init() {
            vm.isAnalyticsMenuActive = isAnalyticsMenuActive;
            vm.isIssueMenuActive = isIssueMenuActive;
            vm.isPeriodicTasksMenuActive = isPeriodicTasksMenuActive;
            vm.isConfigurationMenuActive = isConfigurationMenuActive;

            readMe();
            getCurrentVersion();
            readCompany();
            checkAgreements();
            WebPushService.runFirebaseMessaging();
        }

        function readMe() {
            AuthFactory.readMe().then(
                function (response) {
                    vm.dataFromBackendForDisplayName = response.data;

                    if (
                        AgreementsDialogService.checkIsNewRule(
                            response.data.last_tos_change,
                            response.data.tos
                        )
                    ) {
                        AgreementsDialogService.openAgreement(
                            'termsDialog',
                            'TermsDialogController',
                            'TermsDialogCtrl',
                            '../assets/documents/RegulaminiWykonawca.pdf'
                        );
                    }
                },
                function () {
                    $state.go('login');
                }
            );
        }

        function isIssueMenuActive() {
            return RouteStateService.isActive([
                'company_employee.issue_list',
                'company_employee.report_issue',
                'company_employee.history_issue_list',
            ]);
        }

        function isPeriodicTasksMenuActive() {
            return RouteStateService.isChildrenActive(
                'company_employee.periodic_tasks'
            );
        }

        function isAnalyticsMenuActive() {
            return RouteStateService.isChildrenActive(
                'company_employee.analytics'
            );
        }

        function isConfigurationMenuActive() {
            return RouteStateService.isChildrenActive(
                'company_employee.configuration'
            );
        }

        function checkAgreements() {
            GdprFactory.getAgreementsToAccept().then(function (response) {
                openAgreementsToAccept(response.data.results);
            });
        }

        function openAgreementsToAccept(agreementsToAccept) {
            agreementsToAccept.forEach(function (agreement) {
                switch (agreement.agreement_type) {
                    case 'data_processing':
                        openDataProcessingDialog(agreement.url);
                }
            });
        }

        function openDataProcessingDialog(filePath) {
            AgreementsDialogService.openAgreement(
                'dataProcessingDialog',
                'DataProcessingDialogController',
                'DataProcessingDialogCtrl',
                filePath
            );
        }

        function getCurrentVersion() {
            VersionService.getCurrentVersion().then(function (response) {
                var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
                vm.currentVersion = new Date(
                    response.data.date.replace(pattern, '$3-$2-$1')
                );
            });
        }

        function readCompany() {
            CompanyFactory.readCompany().then(function (response) {
                vm.isManager = response.data.manager;
                vm.companyId = response.data.organization.party_uuid;

                CompaniesFactory.readCompanies(vm.companyId).then(
                    function (companySettings) {
                        vm.inspectionsEnabled =
                            companySettings.data.inspections_enabled;
                    },
                );
            });
        }

        // locale months fixed

        var datetime = $locale.DATETIME_FORMATS;
        var months = datetime.MONTH;

        months[0] = 'Styczeń';
        months[1] = 'Luty';
        months[2] = 'Marzec';
        months[3] = 'Kwiecień';
        months[4] = 'Maj';
        months[5] = 'Czerwiec';
        months[6] = 'Lipiec';
        months[7] = 'Sierpień';
        months[8] = 'Wrzesień';
        months[9] = 'Październik';
        months[10] = 'Listopad';
        months[11] = 'Grudzień';
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/_company_employee/_company_employee.controller.ts